import DatasetDetailPage from "./DatasetDetailPage";

const usStockData = {
  title: "US Stock Prices by Day",
  description:
    "The US Stock Prices by Day dataset delivers coverage of over 5,000 stocks, spanning more than five years of historical data. With daily updates, it offers a scalable and automated solution for accessing pricing metrics, streamlining data analysis and eliminating the complexities of data pipelines.",
  columns: [
    { name: "Run_Date", description: "Date of trading" },
    { name: "Ticker", description: "Unique stock identifier" },
    { name: "Open", description: "Opening Price for the day" },
    { name: "High", description: "Highest traded price for the day" },
    { name: "Low", description: "Lowest traded price for the day" },
    { name: "Close", description: "Closing price for the day" },
    { name: "Volume", description: "Shares traded during the day" },
  ],
  technicalDetails: [
    "Refresh Interval - Daily at 7:30 PM PST",
    "Pricing Interval - Daily",
    "Historical Included - Up to 10 years",
  ],
  urlSnowflake:
    "https://app.snowflake.com/marketplace/listing/GZTSZ1PHJ0A/openmetadata-net-stock-tracking-us-stock-prices-by-day",
  urlDatabricks: "https://databricks.com",
  urlStripe: "",
};

const DatasetUSStock = () => {
  return <DatasetDetailPage dataset={usStockData} />;
};

export default DatasetUSStock;
